export default {
  section2: ['contacts'],
  section3: ['partners'],
  section5: ['results'],
  section6: ['budgetItems', 'countryBudgetItems', 'transactions', 'plannedDisbursements'],
  section7: ['locationItems', 'recipientCountries', 'recipientRegions'],
  section8: ['sectors', 'policyMarkers', 'humanitarianScopes'],
  section9: ['links', 'docs'],
  section11: ['flags', 'forecasts', 'legacies']
}
